import Phaser from 'phaser';
import { GAME_WIDTH, GAME_HEIGHT } from '../config/gameConfig.js';
import { registerGameAtlas } from '../utils/atlas.js';
import { buildBloodstreamBackdrop } from '../utils/bloodstreamBackdrop.js';

/** If tweens/step lag (embedded previews, throttled tabs), still reach the menu. */
const AUTO_ADVANCE_MS = 4200;

function isSkipKey(event) {
  return (
    event.key === 'Enter' ||
    event.code === 'Enter' ||
    event.code === 'NumpadEnter' ||
    event.key === ' ' ||
    event.code === 'Space'
  );
}

export class PreloadScene extends Phaser.Scene {
  constructor() {
    super({ key: 'Preload' });
  }

  create() {
    buildBloodstreamBackdrop(this);

    const title = this.add
      .text(GAME_WIDTH / 2, GAME_HEIGHT * 0.37, 'LOADING VIRUS ASSETS…', {
        fontFamily: 'monospace',
        fontSize: '18px',
        color: '#ffd8df',
      })
      .setOrigin(0.5);

    this.add
      .text(GAME_WIDTH / 2, GAME_HEIGHT * 0.405, 'Enter or Space — skip', {
        fontFamily: 'monospace',
        fontSize: '12px',
        color: '#aa8894',
      })
      .setOrigin(0.5);

    const barY = GAME_HEIGHT * 0.46;
    const barW = 328;
    const barH = 10;
    const barX = GAME_WIDTH / 2 - barW / 2;

    const frame = this.add.graphics();
    frame.lineStyle(2, 0x774455, 1);
    frame.strokeRect(barX - 3, barY - 3, barW + 6, barH + 6);
    frame.fillStyle(0x220812, 1);
    frame.fillRect(barX, barY, barW, barH);

    const barFill = this.add.graphics();

    registerGameAtlas(this);

    const progress = { v: 0 };

    const redrawFill = () => {
      barFill.clear();
      barFill.fillStyle(0xff5577, 1);
      barFill.fillRect(barX, barY, (barW * progress.v) / 100, barH);
      barFill.fillStyle(0xffaab8, 0.65);
      barFill.fillRect(barX, barY, (barW * progress.v) / 100, 3);
    };

    redrawFill();

    let transitioned = false;
    const goMainMenu = () => {
      if (transitioned) return;
      transitioned = true;
      window.removeEventListener('keydown', onWindowKeyDown);
      clearTimeout(autoAdvanceTimer);
      this.tweens.killAll();
      this.scene.start('MainMenu');
    };

    const onWindowKeyDown = (event) => {
      if (!isSkipKey(event)) return;
      event.preventDefault();
      goMainMenu();
    };

    window.addEventListener('keydown', onWindowKeyDown);

    const autoAdvanceTimer = window.setTimeout(goMainMenu, AUTO_ADVANCE_MS);

    this.events.once('shutdown', () => {
      window.removeEventListener('keydown', onWindowKeyDown);
      clearTimeout(autoAdvanceTimer);
    });

    this.tweens.add({
      targets: progress,
      v: 100,
      duration: 960,
      ease: 'Sine.inOut',
      onUpdate: redrawFill,
      onComplete: () => {
        this.time.delayedCall(120, () => {
          const fade = this.add
            .rectangle(GAME_WIDTH / 2, GAME_HEIGHT / 2, GAME_WIDTH + 24, GAME_HEIGHT + 24, 0x000000, 0)
            .setDepth(900)
            .setScrollFactor(0);

          this.tweens.add({
            targets: fade,
            alpha: 1,
            duration: 280,
            ease: 'Quad.in',
            onComplete: goMainMenu,
          });
        });
      },
    });

    this.tweens.add({
      targets: title,
      alpha: { from: 0.45, to: 1 },
      duration: 780,
      yoyo: true,
      repeat: -1,
      ease: 'Sine.inOut',
    });
  }
}
